import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;

  display: flex;
  flex-direction: column;
  padding: 32px;

  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 48px;

    align-items: center;

    padding: 48px;
  }

  ${QUERIES.laptopAndUp} {
    max-width: 1212px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  position: relative;

  aspect-ratio: 6/5;
`;
